// Implements: F-UIX-010
/** A table while it loads (the mockup's `skel('table')`): six rows of grey bars in one announced status region. */

import type { ReactElement } from "react";

import { useTranslation } from "../../i18n";
import { Skeleton } from "../atoms/Skeleton";
import styles from "./TableSkeleton.module.css";

const ROWS = [0, 1, 2, 3, 4, 5] as const;

export function TableSkeleton(): ReactElement {
  const { t } = useTranslation();
  return (
    <div className={styles.table} role="status" aria-busy="true">
      <span className={styles.srOnly}>{t("common.state.loading")}</span>
      {ROWS.map((row) => (
        <div key={row} className={styles.row}>
          <span className={styles.wide}>
            <Skeleton shape="line" />
          </span>
          <span className={styles.narrow}>
            <Skeleton shape="line" />
          </span>
          <span className={styles.narrow}>
            <Skeleton shape="line" />
          </span>
        </div>
      ))}
    </div>
  );
}
